/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardDefinitionAclRoleType {
    getFixupPrototypeFunction() { return DashboardDefinitionAclRoleType.fixupPrototype; }

    static newInstance(model: Partial<DashboardDefinitionAclRoleType>): DashboardDefinitionAclRoleType {
        let obj = Object.assign(new DashboardDefinitionAclRoleType(), model);
        DashboardDefinitionAclRoleType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardDefinitionAclRoleType>): DashboardDefinitionAclRoleType {
        if (!model) return null;
        return DashboardDefinitionAclRoleType.newInstance(<DashboardDefinitionAclRoleType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardDefinitionAclRoleType) {
        if (!obj) return;

        models.DashboardDefinitionAclRoleType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardDefinitionAclRoleType): boolean {
        Object.setPrototypeOf(obj, DashboardDefinitionAclRoleType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    product_bundle: string;

    role_type: string;

}
